export default __webpack_public_path__ + "static/media/style.601eba58.less";